import { Component } from '@angular/core';
import 'devextreme/data/odata/store';
import { EnvironmentService } from '../../services/environment.service';

@Component({
  templateUrl: './batch.component.html',
  styleUrl: './batch.component.scss'
})
export class BatchComponent {
  dataSource: any;
  statusDataSource: any;

  constructor(private environmentService: EnvironmentService) {
    this.dataSource = {
      store: {
        version: 4,
        type: 'odata',
        key: 'Id',
        url: this.environmentService.getConfig('BackendApi') + 'odata/Batches'
      }
    };

    this.statusDataSource = [
      { Id: 1, Value: 'Pending', Color: 'black' },
      { Id: 2, Value: 'Processed', Color: 'green' },
      { Id: 3, Value: 'Rejected', Color: 'red' }
    ];
  }
}
